import type { SortOption } from '@iconik-io/shared-lib/src/utils/sort/types';

export const CUSTOM_ORDER_NAME = 'custom_order';

export const CUSTOM_ORDER: SortOption[] = [
  { name: CUSTOM_ORDER_NAME, order: 'asc' },
];
